import { LANGUAGE_KEYS } from 'config/languageKeys';

import { EventParentalControlRating } from 'services/data-manager/types';

const {
    ACCESSIBILITY: {
        DETAIL_PAGE: {
            ACCESSIBILITY_ICON_GENERAL_AUDIENCE,
            ACCESSIBILITY_ICON_6,
            ACCESSIBILITY_ICON_12,
            ACCESSIBILITY_ICON_16,
            ACCESSIBILITY_ICON_18,
        },
    },
} = LANGUAGE_KEYS;

export function getParentalRatingAccessibilityText(
    parentalRating: EventParentalControlRating | undefined,
) {
    switch (parentalRating) {
        case EventParentalControlRating.HU6:
            return ACCESSIBILITY_ICON_6;
        case EventParentalControlRating.HU12:
            return ACCESSIBILITY_ICON_12;
        case EventParentalControlRating.HU16:
            return ACCESSIBILITY_ICON_16;
        case EventParentalControlRating.HU18:
        case EventParentalControlRating.HU18_ADULT:
        case EventParentalControlRating.HU18_ADULT_UC:
            return ACCESSIBILITY_ICON_18;
        default:
            return ACCESSIBILITY_ICON_GENERAL_AUDIENCE;
    }
}
